export const FETCH_STATS_DATA = 'stats/FETCH_DATA';
export const FETCH_DATASETS_DATA = 'stats/FETCH_DATASETS_DATA';
export const FETCH_SIMULATIONS_DATA = 'stats/FETCH_SIMULATIONS_DATA';
